export enum InsuranceProductsTableFields {
  id = 'id',
  name = 'name',
  description = 'description',
  createdAt = 'createdAt',
  actions = 'actions',
}
